/** @jsx jsx */

import { jsx } from '@emotion/core';

import { LegacyButton } from '@zapier/design-system';

/*
 * This leverages our custom Link component to perform routing.
 */
function LinkButton(props: React.ComponentProps<typeof LegacyButton>) {
  const { href, target, ...buttonProps } = props;

  return <LegacyButton href={href} target={target} {...buttonProps} />;
}

export default LinkButton;
